/**
 * Склонение существительного после числа.
 *
 * Русский требует трёх форм («1 задача», «2 задачи», «5 задач»), и без этого
 * интерфейс выглядит машинным переводом. Правило то же, что у Intl.PluralRules
 * для ru, но без создания объекта локали на каждый вызов.
 */

export type PluralForms = [one: string, few: string, many: string]

export function plural(count: number, forms: PluralForms): string {
  const absolute = Math.abs(count) % 100
  const tail = absolute % 10
  if (absolute > 10 && absolute < 20) return forms[2]
  if (tail > 1 && tail < 5) return forms[1]
  if (tail === 1) return forms[0]
  return forms[2]
}

export function withCount(count: number, forms: PluralForms): string {
  return `${count} ${plural(count, forms)}`
}
